<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Клиенты</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <div v-show="!loading">
                        <CustomersTable
                            :list.sync="items"
                            :filterCount="itemsCount"
                            :use-filter="true"
                            :use-sorter="true"
                            @set-sorter="setSorter"
                            @set-filter="setFilter"
                            @do-export="doExport"
                        />
                        <CPagination
                            :active-page.sync="activePage"
                            class="mt-4"
                            :pages="total"
                            align="center"
                        />
                    </div>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push('/customers/create')"
                    >Создать</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3 float-right"
                        @click="push.modalVisible = true"
                    >Отправить push-уведомление</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
        <CModal
            title="Push-уведомление"
            :show.sync="push.modalVisible"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p class="mb-2">
                        Push-уведомление будет отправлено <b>{{ itemsCount }}</b> клиенту(ам)
                    </p>

                    <CRow class="mt-1">
                        <CCol
                            cols="12"
                            md="4"
                            class="mt-1 d-flex align-items-center">
                            Дата и время отправки
                        </CCol>
                        <CCol
                            cols="12"
                            md="8"
                            class="mt-1 d-flex align-items-center">
                            <DatePicker
                                v-model="push.started_date"
                                :language="datepicker.lang"
                                :format="datepicker.format"
                                class="w-full"
                                input-class="form-control custom-datepicker"
                                placeholder="Дата и время отправки" 
                                hide-details />
                            <CInput
                                v-model="push.started_time"
                                type="time"
                                class="m-0"
                            />
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol
                            cols="12"
                            md="4"
                            class="mt-1 d-flex align-items-center">
                            Заголовок
                        </CCol>
                        <CCol
                            cols="12"
                            md="8"
                            class="mt-1 d-flex align-items-center">
                            <CInput 
                                v-model="push.title" 
                                class="w-full m-0"
                                placeholder="Заголовок" />
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol
                            cols="12"
                            md="4"
                            class="mt-1 d-flex align-items-center">
                            Текст сообщения
                        </CCol>
                        <CCol
                            cols="12"
                            md="8"
                            class="mt-1 d-flex align-items-center">
                            <CTextarea 
                                v-model="push.text" 
                                class="w-full m-0"
                                placeholder="Текст" />
                        </CCol>
                    </CRow>
                    <CRow class="mt-1">
                        <CCol
                            cols="12"
                            md="4"
                            class="mt-1 d-flex align-items-center">
                            Страница, которая открывается при клике на push
                        </CCol>
                        <CCol
                            cols="12"
                            md="8"
                            class="mt-1 d-flex align-items-center">
                            <CInput 
                                v-model="push.link" 
                                class="w-full m-0"
                                placeholder="Ссылка" />
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="push.modalVisible = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="sendPush"
                    >Отправить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import CustomersTable from '@/components/CustomersTable';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {
        name: 'Customers',

        components: {
            DatePicker,
            CustomersTable,
        },

        data() {
            return {
                loading: true,
                items: [],
                itemsCount: 0,
                total: 1,
                sorter: '',
                filter: '',
                timerId: null,
                push: {
                    started_at: null,
                    modalVisible: false,
                    title: '',
                    text: '',
                },
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'loadData',
            sorter: 'loadData',
            filter: 'loadData',
        },

        async mounted() {
            await this.loadData();
        },

        beforeDestroy() {},

        methods: {
            async loadData() {
                this.loading = true;
                let filter = null;
                try {
                    filter = JSON.parse(this.filter);
                } catch (e) {}
                const params = {
                    page: this.activePage,
                    pageSize: ITEMS_PER_PAGE,
                    sorter: this.sorter,
                    filter,
                };
                await Vue.axios
                    .get('/customers', { params })
                    .then(resp => {
                        this.items = resp.data.results;
                        this.itemsCount = resp.data.total;
                        this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки клиентов. ' + err);
                    });
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
            setSorter(sorter) {
                this.sorter = sorter;
            },
            setFilter(filter) {
                this.filter = JSON.stringify(filter);
            },
            sendPush() {
                const this_ = this;
                if(!this.push.title) {
                    this.$root.$emit('showError', 'Введите заголовок push-уведомления.');
                    return;
                }
                if(!this.push.text) {
                    this.$root.$emit('showError', 'Введите текст push-уведомления.');
                    return;
                }
                let filter = null;
                try {
                    filter = JSON.parse(this.filter);
                } catch (e) {}
                Vue.axios
                    .post('/customers/send-push', { 
                        filter,
                        ...this.push
                    })
                    .then(resp => {
                        this_.push.modalVisible = false;
                        this.$root.$emit('showError', 'Push-уведомление успешно отправлено ' + this.itemsCount + ' клиенту(ам).');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка отправки push-уведомления. ' + err);
                    });
            },
            doExport() {
                let filter = null;
                try {
                    filter = JSON.parse(this.filter);
                } catch (e) {}
                const params = {
                    page: this.activePage,
                    pageSize: ITEMS_PER_PAGE,
                    sorter: this.sorter,
                    filter,
                };
                this.axios.get('/export/customers', { responseType: 'blob', params })
                    .then(response => {
                        const bom = decodeURIComponent('%ef%bb%bf')
                        const fileURL = window.URL.createObjectURL(new Blob([bom, response.data], { type: 'text/csv;charset=utf-8' }));
                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', 'Export-MIRCITY-Customers.csv');
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    });
            },
        },
    };
</script>
